module.exports = __webpack_public_path__ + "static/milestonemug1-d286748e580045d82b35abb888ecd8ee.jpeg";